'use strict';

require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');

import React from 'react';
import IconButton from 'components/clarity-ui/inputs/iconButton';
import Thumbnail from 'components/clarity-ui/components/thumbnail/thumbnail';
import Slick from 'react-slick';
import _ from 'lodash';

class VideoResults extends React.Component {

  getThumbnailImageUrl (thumbnailId, frame) {
    return `https://pilbox.set.tv?url=/thumbnail/${thumbnailId}/${frame}&amp;w=245&amp;h=138&amp;mode=scale&amp;frame=${frame}`;
  }

  getThumbnail (item, handlers) {
    const frameInfo = item.currentPosition < 0 ? item.frames[item.defaultFrame] : item.frames[item.currentPosition];
    const frameMark = item.currentPosition < 0 ? item.duration : frameInfo.mark;
    return (
      <div key={item.videoId} className="BreakLine">
        <Thumbnail
          key={item.videoId}
          thumbnailId={item.videoId}
          handleThumbnailOnClick={handlers.handleThumbnailOnClick.bind(this, item)}
          step={item.step}
          onChange={handlers.handleSliderOnChange.bind(this, item)}
          sliderMark={frameMark}
          thumbnailImage={this.getThumbnailImageUrl(item.videoId, frameInfo.frame)}/>
      </div>
    );
  }

  getThumbnailSection (index, slideItems) {
    return (
      <div key={'thslide_'+index}>{ slideItems }</div>
    );
  }

  renderThumbnails () {
    const { videoDetectorResults, ...handlers } = this.props;
    const thumbnails = [];
    var aux = 0;
    while (aux < videoDetectorResults.length) {
      const slideItems = [];
      slideItems.push(this.getThumbnail(videoDetectorResults[aux++], handlers));
      if (aux >= videoDetectorResults.length) { thumbnails.push(this.getThumbnailSection(slideItems)); break; }
      slideItems.push(this.getThumbnail(videoDetectorResults[aux++], handlers));
      if (aux >= videoDetectorResults.length) { thumbnails.push(this.getThumbnailSection(slideItems)); break; }
      slideItems.push(this.getThumbnail(videoDetectorResults[aux++], handlers));
      thumbnails.push(this.getThumbnailSection(aux, slideItems));
    }
    return thumbnails;
  }

  getSlickSettings () {
    return {
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      nextArrow: <IconButton onClick={_.noop()} additionalClassName="SliderIconButtonNext" iconClass="chevronRight" />,
      prevArrow: <IconButton onClick={_.noop()} additionalClassName="SliderIconButtonPrev" iconClass="chevronLeft" />
    };
  }

  render () {
    return (
      <div>
        <Slick {...this.getSlickSettings()}>
          { this.renderThumbnails() }
        </Slick>
      </div>
    );
  }
}

export default VideoResults;



// WEBPACK FOOTER //
// ./src/components/classifier/classifierTargets/targetResults/videoResults/videoResults.component.jsx